"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FUZZY_SEARCH_OPTIONS = exports.fuzzySearch = void 0;
var tslib_1 = require("tslib");
var fuse_js_1 = (0, tslib_1.__importDefault)(require("fuse.js"));
var memoize_1 = (0, tslib_1.__importDefault)(require("lodash/memoize"));
function fuzzySearch(data, searchTerm, options) {
    var searcher = (0, memoize_1.default)(createSearchFn);
    if (searchTerm === '') {
        return data;
    }
    var searchResults = searcher(data, (0, tslib_1.__assign)((0, tslib_1.__assign)({}, exports.DEFAULT_FUZZY_SEARCH_OPTIONS), options)).search(searchTerm);
    return searchResults.map(function (el) { return el.item; });
}
exports.fuzzySearch = fuzzySearch;
function createSearchFn(data, options) {
    return new fuse_js_1.default(data, (0, tslib_1.__assign)((0, tslib_1.__assign)({}, exports.DEFAULT_FUZZY_SEARCH_OPTIONS), options));
}
exports.DEFAULT_FUZZY_SEARCH_OPTIONS = {
    threshold: 0.1,
    ignoreLocation: true,
    fieldNormWeight: 1,
};
//# sourceMappingURL=fuzzy-search.js.map